import React, { Component } from 'react'
import {
    Table,
    Tag,
    Space,
    Input,
    Button,
} from 'antd';
import {
    CheckCircleOutlined,
    PhoneOutlined
} from '@ant-design/icons';
import { home } from '../../../service'
import { PAGINATION } from '../../../utils/constants';
export default class CompanyView extends Component {

    state = {
        dataCompany: [],
        columns: [
            {
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
                render: (text, record, index) => index + 1,
            },
            {
                title: '组织名称',
                dataIndex: 'companyName',
                render: (text) => <a>{text}</a>,
            },
            {
                title: '法人代表',
                dataIndex: 'legalPerson',
            },
            {
                title: '地址',
                dataIndex: 'address',
            },
            // {
            //     title: '联系方式',
            //     render: (_, { phone }) => (
            //         <span><PhoneOutlined /> {phone}</span>
            //     ),
            // },
            {
                title: '认证状态',
                render: (_, { state }) => (
                    <span style={{ color: '#2CB861' }}><CheckCircleOutlined /> 已认证</span>
                ),
            },
        ],
        pagination: PAGINATION,
        queryParams: {
            search: null
        }
    }

    componentDidMount() {
        this.fetch()
    }

    fetch = async (params = { pagination: PAGINATION }) => {
        try {
            const { current, pageSize } = params.pagination
                , { queryParams } = this.state
            const { data: { records, total } } = await home.getCompanyList({ ...queryParams, current, pageSize })

            this.setState({
                dataCompany: records,
                pagination: {
                    ...PAGINATION,
                    current,
                    pageSize,
                    total: total
                }
            })
        } catch (error) {
            console.log(error);
        }
    }

    render() {
        const { dataCompany, columns, pagination } = this.state
        return (
            <div className='container-display-center'>
                <Space.Compact
                    style={{
                        width: '300px',
                        float: 'right',
                        margin: '10px'
                    }}
                >
                    <Input placeholder="请输入名称/地址等" onChange={(e) => this.setState({
                        queryParams: { search: e.target.value }
                    })} />
                    <Button type="primary" onClick={() => this.fetch()}>搜索</Button>
                </Space.Compact>
                <Table
                    columns={columns}
                    dataSource={dataCompany}
                    pagination={pagination}
                    onChange={(pagination) => this.fetch({ pagination })}
                />
            </div>
        )
    }
}
